import { useTheme } from "@mui/material/styles";

import { Avatar } from "../../components/Avatar";
import { Icon } from "../../components/Icon";

/**
 * Dollar sign avatar used in charge rate display sections.
 * Uses useTheme() because the Icon component spreads sx as a plain object,
 * which does not support function-style sx.
 */
export function DollarAvatar() {
  const theme = useTheme();

  return (
    <Avatar
      size="medium"
      sx={{
        backgroundColor: theme.palette.background?.muted,
        flexShrink: 0,
      }}
    >
      <Icon type="dollar" size="small" sx={{ color: theme.palette.base?.inactive }} />
    </Avatar>
  );
}
